import { useSiteConfig } from "@/context/SiteConfigContext";
import { useApply } from "@/context/ApplyContext";
import { STATUS_META } from "@/data/content";

export function AdmissionBadge({ className = "" }) {
  const { config } = useSiteConfig();
  const meta = STATUS_META[config.admissionStatus] || STATUS_META.OPEN;
  return (
    <span
      data-testid="admission-status-badge"
      className={`inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.15em] text-white backdrop-blur-sm ${className}`}
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className="pulse-dot inline-flex h-2.5 w-2.5 rounded-full" style={{ background: meta.dot }} />
      </span>
      {meta.label}
    </span>
  );
}

export function ApplyButton({ className = "btn-red", children, testId = "apply-now-button", onClickExtra }) {
  const { config } = useSiteConfig();
  const apply = useApply();
  const url = (config.applicationUrl || "").trim();

  if (url) {
    return (
      <a data-testid={testId} href={url} target="_blank" rel="noopener noreferrer" className={`${className} btn-lemon-blink`}>
        {children || "Apply Now"}
      </a>
    );
  }
  return (
    <button
      data-testid={testId}
      className={`${className} btn-lemon-blink`}
      onClick={() => {
        apply?.openApply();
        onClickExtra?.();
      }}
    >
      {children || "Apply Now"}
    </button>
  );
}
